import { useState } from 'react';
import { KTCard } from '../../../../_metronic/helpers';
import { ToastTopLeft } from '../../components/ToastTopLeft';
import { TagEditModal } from './tags-edit-modal/ui/TagEditModal';
import { TagModalState } from './tags-table/model/types';
import { FeedTagsTable } from './tags-table/ui/FeedTagsTable';

export const FeedTagsPage = () => {
	const [openModal, setOpenModal] = useState<TagModalState | null>(null);
	const [showErrorToast, setShowErrorToast] = useState(false);

	const handleModalClose = () => {
		setOpenModal(null);
	};

	return (
		<KTCard className='w-100'>
			<FeedTagsTable openModal={openModal} setOpenModal={setOpenModal} />

			{openModal && (
				<TagEditModal
					openModal={openModal}
					handleModalClose={handleModalClose}
					setShowErrorToast={setShowErrorToast}
				/>
			)}

			<ToastTopLeft
				showToast={showErrorToast}
				setShowToast={setShowErrorToast}
				state='danger'
			/>
		</KTCard>
	);
};
